import React from 'react';
import PropTypes from 'prop-types'; // Importing PropTypes
import Card from './Card';
import useIsMobile from '../../../../components/hooks/useIsMobile';
import styles from './cardGrid.scss';
import pageStyles from '../powerPerksPage.scss';

const CardGrid = ({
    isPowered,
    openCard,
    clearOpenCard,
    cards,
    cardsTitle,
    cardsDescription,
    cardButtonText,
    ctaVerb,
    mobileCtaText,
    'data-testid': dataTestId,
}) => {
    const { isMobileWidth } = useIsMobile();

    if (!cards) {
         return null;
    }

    return (
        <div className={styles.cardGrid} id="exclusivePerks">
            {cardsTitle && (
                <div className={`${pageStyles.sectionTitle} ${!cardsDescription && 'mb48'}`} data-testid={dataTestId && `${dataTestId}.title`}>
                    {cardsTitle}
                </div>
            )}
            {cardsDescription && (
                <div className={`${pageStyles.sectionDescription} mb48`} data-testid={dataTestId && `${dataTestId}.description`}>
                    {cardsDescription}
                </div>
            )}
            <div className="row">
                {cards.map((card, index) => {
                    // Only attempt to render cards that have a populated object from statsig
                    if (!card.title) {
                        return null;
                    }
                    return (
                        <div className={`col-md-${card.width?.value}`} key={card.title}>
                            <Card
                                imageUrl={isMobileWidth ? card.image_mobile?.desktop?.default : card.image_desktop?.desktop?.default}
                                title={card.title}
                                description={card.description}
                                isPowered={isPowered}
                                region={card.region}
                                content={card.content}
                                terms={card.terms}
                                link={card.link}
                                code={card.code}
                                method={card.method}
                                isOpen={openCard === card.title}
                                clearOpenCard={clearOpenCard}
                                cardButtonText={cardButtonText}
                                ctaVerb={ctaVerb}
                                mobileCtaText={mobileCtaText}
                                data-testid={dataTestId && `${dataTestId}.card-${index}`}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

// Adding PropTypes validation
CardGrid.propTypes = {
    isPowered: PropTypes.bool.isRequired,
    openCard: PropTypes.string,
    clearOpenCard: PropTypes.func.isRequired,
    cards: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        image_mobile: PropTypes.shape({
            desktop: PropTypes.shape({
                default: PropTypes.string,
            }),
        }),
        image_desktop: PropTypes.shape({
            desktop: PropTypes.shape({
                default: PropTypes.string,
            }),
        }),
        width: PropTypes.shape({
            value: PropTypes.number,
        }),
        region: PropTypes.string,
        content: PropTypes.string,
        terms: PropTypes.string,
        link: PropTypes.string,
        code: PropTypes.string,
        method: PropTypes.string,
    })).isRequired,
    cardsTitle: PropTypes.string,
    cardsDescription: PropTypes.string,
    'data-testid': PropTypes.string,
    cardButtonText: PropTypes.string.isRequired,
    ctaVerb: PropTypes.string.isRequired,
    mobileCtaText: PropTypes.string.isRequired,
};

// Adding default props for non-required props
CardGrid.defaultProps = {
    openCard: '',
    cardsTitle: '',
    cardsDescription: '',
    'data-testid': undefined,
};

export default CardGrid;
